
class exports.Filter

    constructor: (sidebar, filter = {}) ->
        self = this
        @sidebar = sidebar

        @name = filter.name ? ''
        @display_name = filter.display_name ? ''
        @control_type = filter.control_type ? 'dropdown'

        # functionality
        @deletable = filter.deletable ? true
        @enable_depends = filter.enable_depends ? []
        @visible_depends = filter.visible_depends ? []
        @visible = filter.visible ? true
        @enabled = filter.enable ? true
        @refresh_on_delete = filter.refresh_on_delete ? true

        # Range ngModels
        @low_range = ''
        @high_range = ''
        @range_min = filter.range_min ? 0
        @range_max = filter.range_max ? 100

        # data range picker options
        @daterange_format = filter.format ? 'YYYY-MM-DD'
        @daterange_options = filter.options
        @daterange =
            startDate: null
            endDate: null

        if filter.years_filter?
            years = @sidebar.findInGroup filter.years_filter

        @daterange_year_filter = years ? null


        # appearence
        @colors = filter.colors ? []
        @class = filter.class ? ''

        # filter options
        @values = []
        @displayedValues = []
        @selected_values = []

        if filter.onFilterApplied?
            @onFilterApplied = filter.onFilterApplied

        # Returns a value that is between the max and min range
        @validateRange = (range) =>
            range = parseFloat range
            if isNaN range
                return ''

            range = Math.max @range_min, range
            range = Math.min @range_max, range
            return range

        @hasOptions = () =>
            if @control_type not in ['dropdown', 'single_dropdown']
                return true

            for v in @values
                if v.key is null and v.value is null
                    return false
                if not @findVal(v.key, @selected_values)?
                    return true

            return false

        @isVisible = () =>
            # If its hidden return false
            if not @visible
                return false

            # Check to see if visibility dependences
            # allow it to be visible
            for f in @visible_depends
                filter = @sidebar.findInGroup f.name
                if filter
                    for sv in filter.selected_values
                        if sv.value isnt f.selected_value
                            @selected_values = []
                            return false
            # It visibleenabled
            return true

        @isEnabled = () =>
            # If its disabled return false
            if not @enabled
                return false

            # Check to see if enable dependences
            # allow it to be enabled
            for f in @enable_depends
                filter = @sidebar.findInGroup f.name
                if filter
                    for sv in filter.selected_values
                        if sv.value isnt f.selected_value
                            @selected_values = []
                            return false

            # Its enabled If it has options
            return @hasOptions()


        # Set values and pre selected values
        @populateValues(filter.values ? [])
        @populateSelectedValues(filter.selected_values ? [], false)


    handleDateRangePickerChange: () =>
        start = @daterange.startDate.format(@daterange_format)
        end = @daterange.endDate.format(@daterange_format)
        text = start + ' to ' + end

        date_range =
            value: text
            key: text

        @selectFilter(date_range)


    handleRangeChange: () =>
        if @low_range is '' and @high_range is ''
            @selected_values = []
            return
        else if @low_range is '' and @high_range isnt ''
            text = 'less than ' + @high_range
        else if @low_range isnt '' and @high_range is ''
            text = 'greater than ' + @low_range
        else
            text = @low_range + ' to ' + @high_range

        range =
            value: text
            key: text

        @selectFilter(range)


    enableFilter: () =>
        @visible = true
        @enabled = true


    disableFilter: () =>
        @visible = false
        @enabled = false


    assignDisplayName: (name) =>
        @display_name = name


    ###
    Fires when a value is selected in the filter list.
    ###
    selectFilter: (item) =>
        return @applyFilter(item)

    ###
    This is responsible for adding the filter to the selected_values list,
    as well as setting the visible attribute false on the original item so
    it is no longer listed in the actual list of filter values
    ###
    applyFilter: (item) =>

        newitem = {
            key: item.key
            value: item.value
            filterColor: () =>
                c = @findVal(item.value, @colors)
                if c? then return c.color else return ''
        }

        # handle range
        if @control_type is 'range'
            @selected_values = []

            if item.key? and item.value?
                val = item.key

            if val
                newitem.key = val
                newitem.value = val
                @selected_values.push newitem

        # handle date range picker
        if @control_type is 'date_range'
            @selected_values = []

            if item.key? and item.value?
                val = item.key

            if val
                newitem.key = val
                newitem.value = val
                @selected_values.push newitem

        # handle datepicker - not implemented yet
        # if @control_type is 'datepicker'
        #     @selected_values = []

        #     if item.key? and item.value?
        #         val = item.key

        #     if val
        #         newitem.key = val
        #         newitem.value = val
        #         @selected_values.push newitem

        # handle dropdown
        else if @control_type is 'dropdown'
            if not @findVal(item.key, @selected_values)?
                @selected_values.push newitem

        # handle single dropdown
        else if @control_type is 'single_dropdown'
            @selected_values = []
            @selected_values.push newitem

        # handle option
        else if @control_type is 'option'
            # if there's already a value selected, find it's source in the
            # @values array, and ensure it no longer has the "active" class
            # appended to it's css
            if @selected_values.length > 0
                old_value = @findVal(@selected_values[0].key, @values)
                if old_value
                    old_value.extra_class = ''
                @selected_values = []

            # then, add our new value to selected values
            # and set it's source in @values to have the active class
            # so that it's button appears selected
            @selected_values.push newitem

            new_value = @findVal(item.key, @values)

            if new_value isnt false
                new_value.extra_class = 'active'

        if @onFilterApplied?
            @onFilterApplied(self, @selected_values)

    ###
    Fires when a value is selected to be removed from the applied filters.

    This is responsible for removing the clicked item from selected_values,
    and un-hiding the value back in the actual list of filter values (if it is still in the list)
    ###
    unselectFilter: (item) =>
        @low_range = ''
        @high_range = ''
        @daterange =
            startDate: null
            endDate: null
        _.remove @selected_values, (opt) =>
            return opt is item


    ###
    Quick utility method for finding a value in any of our arrays,
    by some kind of object key.
    ###
    findVal: (key, arr, attr = 'key') =>
        if arr?
            return _.find arr, { "#{attr}": key }


    ###
    Ensures filter values are populated correctly
    ###
    populateValues: (vals) =>
        $.each vals, (index, v) =>
            # select2 throws errors if the value is not a string
            if v.value isnt null
                v.value = v.value.toString()
                v.extra_class = ''
                v.filterColor = () =>
                    c = @findVal(v.key, @colors)
                    if c? then return c.color else return ''

        @values = vals



    ###
    Can be used to populate defaults
    ###
    populateSelectedValues: (vals, refresh = true) =>
        for v in vals
            @selectFilter(v, refresh)


    ###
    Check to see if given item is NOT found in the values list
    datepicker's always return false b/c they don't have a values list
    ###
    # valueIsNotAnOption: (item) =>
    #     if @control_type is 'datepicker'
    #         return true
    #     else
    #         s = @findVal(item.key, @values)
    #         if not s?
    #             return true
    #         return false


    ###
    Angular Filter to remove an option found in the selected values list
    ###
    isNotSelectedFilter: (item) =>
        return (item) =>
            return not @findVal(item.key, @selected_values)?
